// AUTO-GENERATED by scripts/generate-tokens.mjs — DO NOT EDIT.
// Source of truth: src/theme/design-tokens.generated.json (key: colors)
//   <- beoflow-design-tokens-sync (Drafted "Beoflow Design System" / foundations/colors)
// Regenerate: npm run tokens:gen   (no-drift gate: npm run tokens:check)
//
// The .generated suffix means DO NOT HAND-EDIT. These are the Beoflow color tokens.
// Mirrors the iOS Beoflow/Theme/ files; values are web-idiomatic (hex/rgba, numeric weights, px).

export const colors = {
  beoBlacker: '#121212',
  beoBlack: '#1E1E1E',
  beoWhite: '#F8F6F4',
  peakOrange: '#FF5D29',
  meanBlue: '#4A9BB8',
  pimpinPurple: '#813656',
  biancchiTeal: '#07B598',
  yoloYellow: '#FFA60B',
  redBase: '#EF4444',
  graphGreyDark: '#434647',
  graphGreyLight: '#DCDCDC',
  navigationOrange: '#A62E08',
  orangeLight: '#FFAE94',
  orangeMid: '#FF8662',
  orangeBase: '#FF5D29',
  orangeDark: '#A62E08',
  blueLight: '#86BED4',
  blueMid: '#68ACC6',
  blueBase: '#4A9BB8',
  blueDark: '#20586E',
  yellowLight: '#FFCE7A',
  yellowMid: '#FFBA43',
  yellowBase: '#FFA60B',
  yellowDark: '#C07A00',
  purpleLight: '#BA688C',
  purpleMid: '#9D4F71',
  purpleBase: '#813656',
  purpleDark: '#502B3B',
  tealLight: '#8FDBCE',
  tealMid: '#4BC8B3',
  tealBase: '#07B598',
  tealDark: '#1C8170',
  redLight: '#FCA5A5',
  redMid: '#F87171',
  redDark: '#B91C1C',
  beoGray: '#DCDCDC',
  beoBackground: '#121212',
  beoBorder: '#F8F6F4',
  beoSecondaryBorder: '#434647',
  exerciseStrengthColor: '#FFAE94',
  exerciseFunctionalColor: '#8FDBCE',
  exerciseCardioColor: '#FCA5A5',
  exerciseRecoveryColor: '#86BED4',
  exerciseBodyweightColor: '#BA688C',
  authError: '#FF5D29',
  authSuccess: '#4A9BB8',
  loginFieldBorderError: '#FF5D29',
  loginPlaceholder: 'rgba(30, 30, 30, 0.5)',
  loginFieldText: '#1E1E1E',
  biometricPrimary: '#4A9BB8',
  biometricSecondary: 'rgba(30, 30, 30, 0.6)',
  metricHeartRate: '#EF4444',
  metricPower: '#4A9BB8',
  metricPace: '#FFA60B',
  metricCadence: '#07B598',
} as const;
export type BeoflowColorName = keyof typeof colors;

export const tints = {
  orange: { light: '#FFAE94', mid: '#FF8662', base: '#FF5D29', dark: '#A62E08' },
  blue: { light: '#86BED4', mid: '#68ACC6', base: '#4A9BB8', dark: '#20586E' },
  yellow: { light: '#FFCE7A', mid: '#FFBA43', base: '#FFA60B', dark: '#C07A00' },
  purple: { light: '#BA688C', mid: '#9D4F71', base: '#813656', dark: '#502B3B' },
  teal: { light: '#8FDBCE', mid: '#4BC8B3', base: '#07B598', dark: '#1C8170' },
  red: { light: '#FCA5A5', mid: '#F87171', base: '#EF4444', dark: '#B91C1C' },
} as const;

export const zoneRamp = { base: '#F8F6F4', opacities: [0.45, 0.38, 0.31, 0.24, 0.17, 0.12, 0.08] } as const;
export const tintPriority = ['orange', 'blue', 'yellow', 'purple', 'green', 'red'] as const;
